<template>
    <section class="singpause-mitglieder-klassen">
        <div class="klassen">
            <h4>Klassenzuweisungen</h4>
            <Table
                bordered
                striped
                small
                showFilter
                :responsive="true"
                :fields="fields"
                :items="items"
                :isBusy="busy"
                :size="size"
                sortBy="from_date"
                emptyText="Es wurden bisher keine Zuweisungen von Klassen für dieses Mitglied vorgenommen"
            >
                <template v-slot:thead-top="{ data }">
                    <b-tr>
                        <b-td :colspan="data.columns - 1"></b-td>
                        <b-td class="text-center">
                            <b-button
                                v-if="checkRight('write')"
                                :size="size"
                                @click="extendAll"
                                variant="link"
                                :disabled="busy || extending.busy"
                                class="mv-table-action-btn"
                                >Alle Übertragen</b-button
                            >
                            <b-button
                                v-if="checkRight('write')"
                                :size="size"
                                @click="duplicateItem(row.id)"
                                variant="link"
                                :disabled="true || printing.busy"
                                class="mv-table-action-btn"
                                >Alle Veträge drucken</b-button
                            >
                        </b-td>
                    </b-tr>
                </template>

                <template v-slot:schule_name="{ row: row }">
                    <b-link
                        :to="{ path: '/mitglieder/' + row.item.schule_id }"
                        >{{ row.value }}</b-link
                    >
                </template>

                <template v-slot:honorar="{ row: row }">
                    {{ currency(row.value) }}
                </template>

                <template v-slot:from_date="{ row: row }">
                    {{ $moment(row.value).format("MM/Y") }}
                </template>

                <template v-slot:to_date="{ row: row }">
                    {{ $moment(row.value).format("MM/Y") }}
                </template>

                <template v-slot:inactive="{ row: row }">
                    <input
                        type="checkbox"
                        v-model="row.item.inactive"
                        true-value="1"
                        false-value="0"
                    />
                </template>
                <template v-slot:actions="{ row: row }">
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="extendItem(row.id)"
                        variant="link"
                        :disabled="busy || extending.busy"
                        class="mv-table-action-btn"
                        >Übertragen</b-button
                    >
                    <b-button
                        v-if="checkRight('write')"
                        :size="size"
                        @click="printContract(row.id)"
                        variant="link"
                        :disabled="printing.busy"
                        class="mv-table-action-btn"
                        >Vertrag drucken</b-button
                    >
                    <b-button
                        v-if="checkRight('delete')"
                        :size="size"
                        @click="removeItem(row.id)"
                        variant="link"
                        class="text-danger mv-table-action-btn"
                        >Löschen</b-button
                    >
                </template>

                <template v-slot:custom-foot>
                    <b-tr>
                        <b-td>Neuen Datensatz anlegen:</b-td>
                        <b-td>
                            <!--<b-select
                                :options="schools.data"
                                :size="size"
                                :disabled="
                                    busy || schools.busy || validate.busy
                                "
                                v-model="newItem.current.schule_id"
                            ></b-select>-->
                            <FilteredSelect
                                :options="schools.data"
                                :size="size"
                                :disabled="
                                    validate.busy || busy || schools.busy
                                "
                                v-model="newItem.current.schule_id"
                            />
                            <template v-if="validate.errors.schule_id">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.schule_id"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input
                                :size="size"
                                :disabled="busy || validate.busy"
                                placeholder="z.B. 5"
                                v-model="newItem.current.klassen"
                            />
                            <template v-if="validate.errors.klassen">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.klassen"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <b-input-group :size="size" append="€"
                                ><b-input
                                    :disabled="busy || validate.busy"
                                    v-model="newItem.current.honorar"
                            /></b-input-group>
                            <template v-if="validate.errors.honorar">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.honorar"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <SchoolYearDateInput
                                :size="size"
                                :disabled="busy || validate.busy"
                                :school_year="selectedSchoolYear"
                                v-model="newItem.current.from_date"
                            />
                            <template v-if="validate.errors.from_date">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.from_date"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td>
                            <SchoolYearDateInput
                                :size="size"
                                :disabled="busy || validate.busy"
                                :school_year="selectedSchoolYear"
                                v-model="newItem.current.to_date"
                            />
                            <template v-if="validate.errors.to_date">
                                <p
                                    class="small text-danger m-0 p-0"
                                    v-for="error in validate.errors.to_date"
                                    :key="error"
                                >
                                    {{ error }}
                                </p>
                            </template>
                        </b-td>
                        <b-td class="text-center"
                            ><input
                                type="checkbox"
                                :size="size"
                                :disabled="busy || validate.busy"
                                true-value="1"
                                false-value="0"
                                v-model="newItem.current.inactive"
                        /></b-td>
                        <b-td
                            ><b-button
                                variant="link"
                                :size="size"
                                :disabled="busy || validate.busy"
                                @click="addItem"
                                >Anlegen</b-button
                            ></b-td
                        >
                    </b-tr>
                </template>
            </Table>
        </div>
        <div class="honorar-sums">
            <h4>Honorare</h4>
            <b-form-group
                :label-cols-sm="3"
                :label-cols-lg="4"
                label="Honorar pro Schuljahr"
                label-for="honorar_year"
                :label-size="size"
                :disabled="honorare.year.busy"
            >
                <b-input-group :size="size">
                    <b-input
                        :size="size"
                        :disabled="true"
                        :value="
                            honorare.year.busy
                                ? 'Lädt...'
                                : currency(honorare.year.value)
                        "
                    />
                    <b-input-group-append is-text>
                        Schuljahr:
                        <b>{{ printSchoolYear(selectedSchoolYear) }}</b>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
            <b-form-group
                :label-cols-sm="3"
                :label-cols-lg="4"
                label="Honorar Monat"
                label-for="honorar_month"
                description="Berechnet sich automatisch aus der Klassenanzahl und dem Honorar in der oben gezeigten Tabelle"
                :label-size="size"
                :disabled="honorare.month.busy"
            >
                <b-input-group :size="size">
                    <b-input
                        :size="size"
                        :disabled="true"
                        :value="
                            honorare.month.busy
                                ? 'Lädt...'
                                : currency(honorare.month.value)
                        "
                    />

                    <b-input-group-append is-text>
                        Monat: <b>{{ $moment(currentDate).format("MM/Y") }}</b>
                    </b-input-group-append>
                </b-input-group>
            </b-form-group>
        </div>
    </section>
</template>

<script>
import shortid from "shortid";
import CommonView from "@/mixins/CommonView/CommonView";
import Size from "@/mixins/Size/Size";
import Currency from "@/mixins/Currency/Currency";
import SingPause from "@/mixins/SingPause/SingPause";
import SingPauseKlassen from "@/mixins/SingPause/SingPauseKlassen";
import { ApiFactory } from "@/api/ApiFactory.js";
import { BlobUtil } from "@/utils/BlobUtil.js";
import Table from "@/components/Table/Table";
import FilteredSelect from "@/components/FilteredSelect/FilteredSelect";
import SchoolYearDateInput from "@/components/SchoolYearDateInput/SchoolYearDateInput";

const SingPauseApi = ApiFactory.get("singpause");

export default {
    name: "SingPauseMitgliederKlassen",
    mixins: [CommonView, Size, Currency, SingPause, SingPauseKlassen],
    props: ["id", "schools", "refresh"],
    components: {
        Table,
        FilteredSelect,
        SchoolYearDateInput
    },
    data() {
        return {
            api: SingPauseApi,
            fields: [
                {
                    key: "id",
                    label: "ID",
                    sortable: true
                },
                {
                    key: "schule_name",
                    label: "Schule",
                    sortable: true
                },
                {
                    key: "klassen",
                    label: "Anzahl Klassen",
                    class: "text-center"
                },
                {
                    key: "honorar",
                    label: "Honorar",
                    thClass: "text-left",
                    tdClass: "text-right"
                },
                {
                    key: "from_date",
                    label: "von",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "to_date",
                    label: "bis",
                    sortable: true,
                    class: "text-center"
                },
                {
                    key: "inactive",
                    label: "inaktiv",
                    class: "text-center"
                },
                {
                    key: "actions",
                    label: "Aktionen",
                    class: "text-center"
                }
            ],
            honorare: {
                year: {
                    busy: false,
                    value: null
                },
                month: { busy: false, value: null }
            },
            newItem: {
                default: {
                    id: null,
                    schule_id: null,
                    klassen: null,
                    honorar: null,
                    from_date: null,
                    to_date: null,
                    inactive: false
                },
                current: {
                    id: null,
                    schule_id: null,
                    klassen: null,
                    honorar: null,
                    from_date: null,
                    to_date: null,
                    inactive: false
                }
            },
            validate: {
                busy: false,
                errors: {}
            }
        };
    },
    created() {
        this.fetchHonorarYear();
        this.fetchHonorarDate();
    },
    watch: {
        selectedSchoolYear: {
            handler() {
                this.fetch();
                this.fetchHonorarYear();
            }
        },
        items: {
            handler(val) {
                this.$emit("update", val);
            },
            deep: true,
            immediate: true
        },
        refresh: {
            handler() {
                this.fetch();
                this.fetchHonorarYear();
                this.fetchHonorarDate();
            }
        }
    },
    methods: {
        async fetch() {
            this.busy = true;
            const response = await this.api.getKlassenForSingleiterInYear(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok && response.json.collection) {
                var items = response.json.collection;
                items = items.map(item => this.process(item));
                this.items = items;
                this.registerRights(response);
            } else {
                this.items = [];
                this.registerRights(response);
            }
            this.busy = false;
        },
        async fetchHonorarYear() {
            this.honorare.year.busy = true;
            const response = await this.api.getHonorarForSingleiterInYear(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok) {
                this.honorare.year.value = response.json.total;
                this.registerRights(response);
            }
            this.honorare.year.busy = false;
        },
        async fetchHonorarDate() {
            this.honorare.month.busy = true;
            const response = await this.api.getHonorarForSingleiterAtDate(
                this.id,
                this.currentDate
            );
            if (response.ok) {
                this.honorare.month.value = response.json.total;
                this.registerRights(response);
            }
            this.honorare.month.busy = false;
        },
        async addItem() {
            this.newItem.current["id"] = "new_" + shortid.generate();
            const school = this.schools.data.filter(
                item => item.value == this.newItem.current["schule_id"]
            );
            if (school.length > 0) {
                this.newItem.current["schule_name"] = school[0]["text"];
            }
            this.validate.busy = true;
            const validate = await SingPauseApi.validateKlassen(
                this.id,
                this.newItem.current
            );
            if (validate.ok) {
                this.items.push(this.newItem.current);
                this.newItem.current = { ...this.newItem.default };
                this.validate.errors = {};
            } else {
                console.error("Validaton error:", validate);
                this.validate.errors = validate.json.validation;
            }
            this.validate.busy = false;
        },
        removeItem(id) {
            this.items = this.items.filter(item => item.id !== id);
        },
        async extendAll() {
            this.extending.busy = true;
            const response = await SingPauseApi.extendMultipleKlassenEntriesForSingleiter(
                this.id,
                this.selectedSchoolYear
            );
            if (response.ok) {
                this.makeToast(
                    "Übertragung erfolgreich",
                    `Der ausgewählten Datensätze wurden korrekt in das nächste Schuljahr übertragen`
                );
            } else {
                this.makeToast(
                    "Übertragung fehlerhaft",
                    `Der ausgewählten Datensätze wurde nicht übertragen!`,
                    "danger"
                );
            }
            this.extending.busy = false;
        }
    }
};
</script>
